// extracted by mini-css-extract-plugin
export default {"Title":"ModalError_Title__TjMdg","Desc":"ModalError_Desc__ei-eg","Btn":"ModalError_Btn__fBP-B"};